import StudentsManagementService from '../students-management-service'

export default new StudentsManagementService('/api/admin/course')
